<template>
  <label v-if="$slots.default" :class="labelClasses">
    <slot />
  </label>
</template>

<script>
export default {
  props: {
    labelClasses: {
      type: [String, Array, Object],
      default: 'text-[0.875rem] leading-[1.25rem] mb-[4px] block',
    },
  },
};
</script>
